// components/LottiePlayer.js
import React, { useEffect, useRef } from 'react';
import lottie from 'lottie-web';

const LottiePlayer = ({ 
  animationPath, 
  width = '100%', 
  height = '100%',
  maxWidth = '300px',
  maxHeight = '300px'
}) => {
  const containerRef = useRef();
  const animInstance = useRef(null);
  
  useEffect(() => {
    // Initialize animation
    animInstance.current = lottie.loadAnimation({
      container: containerRef.current,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: animationPath, // path to your .json file
    });
    
    // Handle window resize for responsiveness
    const handleResize = () => {
      if (animInstance.current) {
        // Force a redraw on resize
        animInstance.current.resize();
      }
    };
    
    window.addEventListener('resize', handleResize);
    
    // Cleanup function
    return () => {
      if (animInstance.current) {
        animInstance.current.destroy();
      }
      window.removeEventListener('resize', handleResize);
    };
  }, [animationPath]);
  
  return (
    <div 
      ref={containerRef} 
      style={{ 
        width, 
        height,
        maxWidth, 
        maxHeight,
        background: 'transparent',
        margin: '0 auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
      }} 
      className="responsive-lottie-container"
    />
  );
};

export default LottiePlayer;